import { render } from "./BellTent.vue?vue&type=template&id=17e540e3"
import script from "./BellTent.vue?vue&type=script&lang=js"
export * from "./BellTent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__